import { freeze } from 'utils/dom'
import { intcmp } from 'utils/string'

// import { MENU_PUSH } from './generate'
import { normalizeNavPoint } from './normalize'

////////////////////////////////////////////////////////////////////////////////
export function buildConfigs(config) {
  const normal = freeze(config.reduce(normalizeNavPoint, []))
  const { tabs } = normal.reduce(reduceTabs, { tabs: {}, normal })
  const { menus } = normal.reduce(reduceMenus, { menus: [], normal })
  // const { menus } = normal.reduce(buildMenus, { menus: {}, normal })
  return {
    normal,
    ROUTES: freeze(normal.reduce(buildRoutes, [])),
    SITEMAP: freeze(normal.reduce(buildSiteMap, {})),
    MENUS: orderMenus(menus),
    TABS: orderMenus(tabs)
  }
}

////////////////////////////////////////////////////////////////////////////////
const HEAD = Symbol('HEAD')
const ADD = Symbol('ADD')
function getTabMenu(ref, key) {
  return ref[key] || { head: undefined, items: [] }
}

function orderMenus(orig) {
  // only one level deep
  return Object.keys(orig).reduce((acc, key) => {
    let { head, items } = orig[key]
    items = items
      .map(({ order, item }, x) => {
        if (order === null) return { order: x, item }
        return { order, item }
      })
      .sort((a, b) => intcmp(a.order, b.order))
      .map(({ item }) => item)
    acc[key] = { head, items }
    return acc
  }, {})
}

////////
function reduceMenus({ normal, menus }, route) {
  menus = { ...menus }

  if (!route.nav) return { normal, menus }

  const { menuHead, menuAdd } = route.nav

  menus = enrichTabMenu(menus, HEAD, menuHead, route.id)
  menus = enrichTabMenu(menus, ADD, menuAdd, route.id)

  if (route.children) return route.children.reduce(reduceMenus, { normal, menus })
  return { normal, menus }
}

////////////////////////////////////////////////////////////////////////////////
function reduceTabs({ normal, tabs }, route) {
  tabs = { ...tabs }

  if (!route.nav) return { normal, tabs }

  const { tabHead, tabAdd } = route.nav

  tabs = enrichTabMenu(tabs, HEAD, tabHead, route.id)
  tabs = enrichTabMenu(tabs, ADD, tabAdd, route.id)

  if (route.children) return route.children.reduce(reduceTabs, { normal, tabs })

  return { normal, tabs }
}

function enrichTabMenu(acc, what, spec, itemId) {
  if (!spec) return acc
  return spec.value.reduce(
    (acc, tabGroup) =>
      enrichTab_(what, acc, tabGroup, { order: spec.order, item: itemId }),
    acc
  )
}

function enrichTab_(what, acc, tabGroup, item) {
  switch (what) {
    case ADD: {
      let { head, items } = getTabMenu(acc, tabGroup)
      acc[tabGroup] = { head, items: items.concat(item) }
      return acc
    }

    case HEAD: {
      let { items } = getTabMenu(acc, tabGroup)
      acc[tabGroup] = { head: item, items }
      return acc
    }

    default:
      throw new Error('invalid tab type to enrich')
  }
}

////////////////////////////////////////////////////////////////////////////////
function buildSiteMap(map, route) {
  const {
    route: { path },
    children,
    nav,
    ...rest
  } = route

  // possibly flatten nav
  map[route.id] = freeze({
    ...rest,
    path,
    basePath: rest.pathTo({}),
    nav: freeze(nav),
    children: children.map(({ id }) => id)
  })

  return children.reduce(buildSiteMap, map)
}

////////////////////////////////////////////////////////////////////////////////
function buildRoutes(routes, { route, children }) {
  if (route.index) {
    route = { ...route }
    route.children = undefined
    return routes.concat(route)
  } else if (!route.path) {
    return routes
  } else {
    return routes.concat({
      ...route,
      children: freeze(children.reduce(buildRoutes, []))
    })
  }
}
